(function () {
  'use strict';

  angular.module('lif.controllers').controller('loginController', loginController);
  loginController.$inject = ['$scope'];

  function loginController($scope) {
    var vm = this;
  }

  ;
})();